module.exports = __webpack_public_path__ + "img/2.e110b6f9.png";